module.exports = __webpack_public_path__ + "img/img-add-child-account.82f97451.png";